import React from 'react'
import { MapContainer, TileLayer, Popup , Marker} from 'react-leaflet'

import {HeroParallax, Box} from '../components'
import {boxMenu, boxContact} from '../utils/links'
import img from '../assets/home.webp'
import cups from '../assets/cups.jpeg'
import imgContact from '../assets/contact.webp'

function HomeScreen() {
    return (
        <div>
            <HeroParallax img={img} height={"800px"} classParallax="home-parallax" classHeight="home-parallax-height">
                <div className="main-logo"/>
            </HeroParallax>
            <div className="border-top"/>
            <div className="container-section">
                <div className="text-section">
                    <h1 className="title">Il Flauto Magico</h1>
                    <hr/>
                    <h5 className="title" style={{marginBottom:"30px"}}>Sala da tè</h5>
                    <p style={{marginBottom:"30px"}}>Per molti il flauto magico è o è stato un punto di ritrovo e di condivisione, un posto accogliente dove poter scambiare due chiacchiere interessanti, pensare e perché no, creare... <br/> È come una dolce melodia che ti cattura e ti fa stare bene, insieme all'allegra compagnia del mitico Settimio.</p>
                    <hr style={{marginBottom:"30px"}}/>
                    <div className="container-column" style={{marginBottom:"30px"}}>
                        <div>
                            <img src={cups} alt="Tazze Flauto Magico" className="column-image"/>
                        </div>
                        <div className="text-section">
                            <p className="poem">Sullo stesso luogo <br/>
                                Aria di casa, di centro, di quartiere<br/>
                                per anni e anni, ovunque io giri.<br/>
                                Ti ho creato nella gioia e nel pianto:<br/>
                                tanti sono i fatti, tanti gli eventi<br/>
                                che sei diventato tutto sentimento, per me.</p>
                            <p style={{fontFamily:"sans-serif", paddingTop:0,}}>Costantino Kavafis</p>
                        </div>
                    </div>
                    <hr/>
                    <h2 className="title" style={{margin:"20px"}}>Consiglio del giorno</h2>
                    <hr style={{marginBottom:"10px"}}/>
                    <Box {...boxMenu}/>
                   
                </div>
            </div>
            <div className="border-bottom"/>
            <HeroParallax overlay img={imgContact} height={"400px"} classParallax="contact-parallax" classHeight="contact-parallax-height">
                <div style={{display:"grid", justifyContent:"space-between", alignItems:"center", height:"50%", margin:"20px"}}>
                    <hr/>
                    <h4 className="title hero-title">Sala da Tè con oltre 40 anni di esperienza.</h4>
                    <hr/>
                </div>
            </HeroParallax>
            <div className="border-top"/>
            <div className="container-section">
                <div className="text-section">
                    <hr/>
                    <h2 className="title" style={{margin:"20px"}}>Contattaci!</h2>
                    <hr style={{marginBottom:"10px"}}/>
                    <Box {...boxContact} contact/>
                </div>
            </div>
            <div className="border-bottom"/>
            <div style={{height:"400px", width:"100%"}}>
                <MapContainer center={[42.95229, 13.88043]} zoom={13} scrollWheelZoom={false} dragging={false} style={{height:"400px"}}>
                    <TileLayer
                        attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <Marker position={[42.95229, 13.88043]} ref={(el)=>{setTimeout(()=>{el.openPopup()}, 1)}} >
                        <Popup keepInView={true}>
                            <h5>Il Flauto Magico</h5>
                            <p>Via Custoza 31
                            San Benedetto del Tronto - 63074 (AP)</p>
                        </Popup>
                    </Marker>
                </MapContainer>
            </div>
            
            
        </div>
    )
}

export default HomeScreen;
